import StatusChip from "../../../StatusChip";

const NewMetricExtensionRowTag = () => {
  return <StatusChip label="New" color={(t) => t.palette.info.main} />;
};

export default NewMetricExtensionRowTag;
